import axiosInstance from './axiosConfig';

export const loginApi = (email, password) =>
  axiosInstance.post('/auth/login', { email, password });

export const logoutApi = () => axiosInstance.post('/auth/logout');

export const meApi = () => axiosInstance.get('/auth/me');

export const forgotPasswordApi = (email) =>
  axiosInstance.post('/auth/forgot-password', { email });

export const resetPasswordApi = (token, password) =>
  axiosInstance.put('/auth/reset-password', { token, password });



// ---------- ورود دو مرحله‌ای و امنیت حساب ----------

// _retry: true یعنی «برای 401 تلاش به refresh نکن» (این درخواست‌ها قبل از ورود کامل انجام می‌شوند)
const NO_REFRESH = { _retry: true };

export const verifyTwoFactorApi = (twoFactorToken, code) =>
  axiosInstance.post('/auth/login/2fa', { twoFactorToken, code }, NO_REFRESH);

export const startTwoFactorSetupApi = (setupToken) =>
  axiosInstance.post('/auth/2fa/setup', setupToken ? { setupToken } : {}, setupToken ? NO_REFRESH : undefined);

export const confirmTwoFactorSetupApi = (code, setupToken) =>
  axiosInstance.post(
    '/auth/2fa/enable',
    setupToken ? { code, setupToken } : { code },
    setupToken ? NO_REFRESH : undefined
  );

export const disableTwoFactorApi = (password, code) =>
  axiosInstance.post('/auth/2fa/disable', { password, code });

export const regenerateBackupCodesApi = (password, code) =>
  axiosInstance.post('/auth/2fa/backup-codes', { password, code });

export const getSecurityInfoApi = () => axiosInstance.get('/auth/security');

export const changePasswordApi = (currentPassword, newPassword) =>
  axiosInstance.post('/auth/change-password', { currentPassword, newPassword });

export const requestUnlockApi = (email, message) =>
  axiosInstance.post('/auth/unlock-request', { email, message }, NO_REFRESH);
